// extracted by mini-css-extract-plugin
module.exports = {"searchForm":"components_searchForm__44nxc","statisticsCard":"components_statisticsCard__3fiSr"};